module.exports = __webpack_public_path__ + "static/img/shilla-ipark.0598345.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/shilla-ipark.png
// module id = +tGA
// module chunks = 0